module.exports = __webpack_public_path__ + "img/pink-ribbon.49930ad6.svg";